class PayoutBookingRecordDataModel {
  constructor(props) {
    this.id = props.id;

    this.bookingId = props.bookingId;

    this.startAt = props.startAt;

    this.endAt = props.endAt;

    this.date = props.date;

    this.amount = props.amount;

    this.bookingId = props.bookingId;

    this.consumer = {
      id: props.consumer.id,
      firstName: props.consumer.firstName,
      lastName: props.consumer.lastName,
      displayName: props.consumer.displayName
    };

    this.land = {
      id: props.land.id,
      name: props.land.name
    };
  }
}

export default PayoutBookingRecordDataModel;
